import React, { useEffect, useState,useGlobal } from "reactn";
import { useParams } from 'react-router-dom'
import { Row, Col, Form, Input, Button, Card, message, Select, Switch, DatePicker, Alert, InputNumber } from 'antd';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from "@ant-design/icons";
import { FileInputSingle, QuestionSetPicker } from '../components';
import { Link } from 'react-router-dom';
import { useCallback } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import firebaseDb from '../firebase';
import moment from 'moment';
import axios from 'axios';
import { nanoid } from 'nanoid';

const StreamsDetail = (props) => {
    let params = useParams()
    let history = useHistory()
    let id = params.id !== "add" ? params.id : false;

    let newRecord = {
        lang: 'TR',
        name: null,
        active: false,
        order: 1,
        required: false,
        media: null,
        streamStartDate: moment(new Date()),
        streamEndDate: moment(new Date()),
        competitionStartDate: moment(new Date()),
        competitionEndDate: moment(new Date()),
        informationVideoUrl: null,
        liveStreamUrl: null,
        timerDownColor: "#ffffff",
        timerDownCounter: ""
    }

    let [data, setData] = useState(id ? [] : newRecord);
    let [errors, setErrors] = useState([]);
    let [loading, setLoading] = useState(id ? true : false);
    let [validationCheck, setValidationCheck] = useState(false)
    let [token, setToken] = useGlobal('token');
    console.log(token);
    
    //onetime run
    useEffect(() => {
        if (id) {
            setLoading(true)
            get()
        }
    }, [id]);

    let get = async () => {
        const streamRef = doc(firebaseDb, "stream", id);
        const streamSnap = await getDoc(streamRef);

        if (streamSnap.exists()) {
            setData({
                ...streamSnap.data(),
                id: streamSnap.id
            });
            setLoading(false)
        }

    }

    let validate = useCallback(() => {
        let errors = {};

        if (data.name === null)
            errors.name = 'Zorunlu Alan!'

        if (data.media === null)
            errors.media = 'Zorunlu Alan!'

        if (data.streamStartDate === null)
            errors.streamStartDate = 'Zorunlu Alan!'

        if (data.streamEndDate === null)
            errors.streamEndDate = 'Zorunlu Alan!'

        if (data.competitionStartDate === null)
            errors.competitionStartDate = 'Zorunlu Alan!'

        if (data.competitionEndDate === null)
            errors.competitionEndDate = 'Zorunlu Alan!'

        if (data.liveStreamUrl === null)
            errors.liveStreamUrl = 'Zorunlu Alan!'

        errors.all = Object.getOwnPropertyNames(errors).map(n => errors[n]);
        errors.hasError = errors.all.length > 0;
        return errors;
    }, [data]);

    useEffect(() => { if (validationCheck) setErrors(validate()) }, [validationCheck, data, validate]);

    let save = async () => {
        setValidationCheck(true)
        let err = validate()

        if (err.hasError) {
            setErrors(err)
            window.scrollTo({ top: 20, behavior: 'smooth' });
        }
        else {
            let options = { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
            let dateData = data.streamStartDate.toDate().toLocaleDateString('tr-TR', options)

            if (data.streamStartDate._d) {
                data.sessionId = await axios.get("https://futurelive-api.eventapp.app/rest/session").then(resp => {
                    return resp.data.opentokSessionId
                });
            }

            if (data.streamStartDate._d)
                data.streamStartDate = data.streamStartDate._d
            if (data.streamEndDate._d)
                data.streamEndDate = data.streamEndDate._d
            if (data.competitionStartDate._d)
                data.competitionStartDate = data.competitionStartDate._d
            if (data.competitionEndDate._d)
                data.competitionEndDate = data.competitionEndDate._d

            if (data.questionSetId) {
                const questionSetRef = await doc(firebaseDb, "questionSet", data.questionSetId);
                const questionSetSnap = await getDoc(questionSetRef);
                data.questionSetUrl = await questionSetSnap.data().questionSetUrl
                data.timerDownCounter = dateData
            }

            if (id) {
                await setDoc(doc(firebaseDb, "stream", id), { ...data });
                message.success("Bilgiler güncellendi", 2);
                history.push('/streams')

            } else {
                id = nanoid(20)
                data.id = id
                await setDoc(doc(firebaseDb, "stream", id), { ...data });
                message.success("Kayıt Başarılı bir şekilde eklendi.", 2);
                history.push('/streams')
            }
        }
    };

    const { Option } = Select;

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Yayınlar"}</h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/streams">
                        <Button className="button4" type="light" icon={<LeftOutlined />} size="large">GERİ</Button>
                    </Link>
                </div>
            </div>
            <div className="form-wrap">
                <Card title={id ? "Düzenle" : "Ekle"} loading={loading}>
                    <Form layout="horizontal" size={"large"} onFinish={save}>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Dil" help={errors.lang} validateStatus={errors.lang ? 'error' : 'success'}>
                                    <Select className="button4" defaultValue={(data.lang) ? data.lang : 'user'} style={{ width: 120 }} onChange={v => { setData({ ...data, lang: v }) }}>
                                        <Option value="TR">Türkçe</Option>
                                        < Option value="EN">İngilizce</Option>
                                        < Option value="DE">Almanca</Option>
                                        < Option value="AZ">Azerice</Option>
                                        < Option value="RU">Rusça</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="İsim" required help={errors.name} validateStatus={errors.name ? 'error' : 'success'}>
                                    <Input className="button4" name="name" value={data.name} onChange={e => setData({ ...data, name: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Durumu" help={errors.active} validateStatus={errors.active ? 'error' : 'success'}>
                                    <Switch className="button4" checked={data.active ? true : false} checkedChildren="Aktif" unCheckedChildren="Pasif" onChange={v => setData({ ...data, active: v })} />
                                    <Alert type="info" message="Yayın başlama tarihinde aktif, yayın bitiş tarihinde pasif olacaktır!" banner />

                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Sıra" help="Sıra seçilmediği taktirde sıralaması 1 olacak şekilde ayarlanır.">
                                    <InputNumber name="order" value={data.order} onChange={v => setData({ ...data, order: v })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col span={12}>
                                <Form.Item required label="Kapak Resmi" help={errors.media} validateStatus={errors.media ? 'error' : 'success'}>
                                    <FileInputSingle className="button4" record={data} setRecord={setData} name="media" fileName="streams" />
                                    <Alert type="info" message="16x9 oranında görsel yükleyiniz." banner />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                                <Form.Item label="Yayın Başlama Tarihi" required help={errors.streamStartDate} validateStatus={errors.streamStartDate ? 'error' : 'success'}>
                                    <DatePicker className="button4" defaultValue={() => moment(data.streamStartDate.toDate())} onChange={v => setData({ ...data, streamStartDate: v })} format='DD/MM/YYYY HH:mm' showTime={true} />
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                                <Form.Item label="Yayın Bitiş Tarihi" required help={errors.streamEndDate} validateStatus={errors.streamEndDate ? 'error' : 'success'}>
                                    <DatePicker className="button4" defaultValue={() => moment(data.streamEndDate.toDate())} onChange={v => setData({ ...data, streamEndDate: v })} format='DD/MM/YYYY HH:mm' showTime={true} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Soru Seti" help={errors.questionSetId} validateStatus={errors.questionSetId ? 'error' : 'success'}>
                                    <QuestionSetPicker disabled={id ? true : false} record={data} setRecord={setData} name="questionSetId" />
                                    <Alert type="info" message="Bu alan tekrar düzenlenemez!" banner />
                                </Form.Item>
                            </Col>
                        </Row>
                        {data.questionSetId &&
                            <Row direction="row">
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                                    <Form.Item label="Yarışma Baş. Tarihi" required help={errors.competitionStartDate} validateStatus={errors.competitionStartDate ? 'error' : 'success'}>
                                        <DatePicker className="button4" defaultValue={() => moment(data.competitionStartDate.toDate())} onChange={v => setData({ ...data, competitionStartDate: v })} format='DD/MM/YYYY HH:mm' showTime={true} />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 12 }}>
                                    <Form.Item label="Yarışma Bitiş Tarihi" required help={errors.competitionEndDate} validateStatus={errors.competitionEndDate ? 'error' : 'success'}>
                                        <DatePicker className="button4" defaultValue={() => moment(data.competitionEndDate.toDate())} onChange={v => setData({ ...data, competitionEndDate: v })} format='DD/MM/YYYY HH:mm' showTime={true} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Yayın Linki" required help={errors.liveStreamUrl} validateStatus={errors.liveStreamUrl ? 'error' : 'success'}>
                                    <Input className="button4" name="liveStreamUrl" value={data.liveStreamUrl} onChange={e => setData({ ...data, liveStreamUrl: e.target.value })} />
                                    <p>Sadece yayın linki desteklenir.</p>
                                </Form.Item>
                            </Col>
                        </Row>
                        {/* <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Tanıtım Videosu Linki" help={errors.informationVideoUrl} validateStatus={errors.informationVideoUrl ? 'error' : 'success'}>
                                    <Input className="button4" name="informationVideoUrl" value={data.informationVideoUrl} onChange={e => setData({ ...data, informationVideoUrl: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row> */}
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                <Form.Item label="Katılım Kodu">
                                    <Switch className="button4" checked={data.required ? true : false} checkedChildren="Var" unCheckedChildren="Yok" onChange={v => setData({ ...data, required: v })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col xs={{ span: 24 }} md={{ span: 18 }}>
                                <Form.Item label="Tarih Rengi" required help={errors.timerDownColor} validateStatus={errors.timerDownColor ? 'error' : 'success'}>
                                    <Input className="button4" name="timerDownColor" value={data.timerDownColor} onChange={e => setData({ ...data, timerDownColor: e.target.value })} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row direction="row">
                            <Col span={24}>
                                <Form.Item>
                                    <Button className="button4" type="primary" disabled={loading} htmlType="submit" size="large" block > KAYDET </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </div>
        </div>
    );
};

export default StreamsDetail;
